module.exports = __webpack_public_path__ + "city.78a14a0bdf1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/marketing/home/city.jpg
// module id = ./src/styles/marketing/home/city.jpg
// module chunks = 21